export default {
  services_number_title: "Anzahl der wählbaren Dienstleistungen",
  additional_information_after_booking_title:
    "Zusätzliche Informationen in der E-Mail nach der Buchung",
  additional_information_after_booking_subtitle:
    "Zusätzliche Informationen, die in E-Mails im Zusammenhang mit Servicebuchungen gesendet werden (Erstellung, Änderung und Erinnerungen an die Buchung). Wenn du die Benachrichtigungen bearbeitet hast, stelle sicher, dass die entsprechende Variable in deren Inhalt festgelegt ist: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "Dies ist ein Beispieltext, der durch zusätzliche Informationen nach der Buchung ersetzt wird, sofern diese in den Serviceeinstellungen angegeben wurden.",
  plugins_storage_100gb_cd_base_pro_name: "Dateispeicher 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Dateispeicher 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Mehr Speicherplatz für Dateien. Gewinne 100 GB zusätzlichen Platz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare zu empfangen. Eine ideale Lösung, um die Kommunikation zu verbessern und den Kundenservice zu optimieren.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maximaler Speicherplatz für deine Dateien. Nutze 500 GB Speicherplatz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare ohne Einschränkungen zu empfangen. Unverzichtbar für schnell wachsende Unternehmen, die Professionalität und Komfort schätzen.",
  bookings_this_month: "Buchungen diesen Monat",
  bookings_all_processed: "Alle Buchungen",
  simple_store_product_transactions_this_month:
    "Verkaufte Produkte diesen Monat",
  files_storage_usage: "Genutzter Speicherplatz",
  files_storage_usage_from_available_prefix: "von verfügbaren",
  not_available_in_standard_plan: "Funktion nicht im Standardplan verfügbar",
  cancel_reason_dropdown_label: "Grund für die Kündigung des Abonnements",
  cancel_subscription_category_1_title: "Technische Probleme",
  cancel_subscription_category_1_reason_1_title:
    "Häufige Abstürze oder Ausfälle",
  cancel_subscription_category_1_reason_2_title: "Langsame Systemleistung",
  cancel_subscription_category_1_reason_3_title:
    "Schwer zu bedienende Benutzeroberfläche",
  cancel_subscription_category_1_reason_4_title:
    "Probleme mit Integrationen (z. B. Zahlungssystem, externe Kalender)",
  cancel_subscription_category_1_reason_5_title:
    "Sicherheitsbedenken (z. B. Datenschutzverletzungen)",
  cancel_subscription_category_1_reason_6_title:
    "Probleme mit der mobilen Mitarbeiter-App (z. B. Abstürze, Bugs)",
  cancel_subscription_category_2_title:
    "Persönliche oder geschäftliche Veränderungen",
  cancel_subscription_category_2_reason_1_title:
    "Änderung des Geschäftsmodells (z. B. geringerer Bedarf an Buchungen)",
  cancel_subscription_category_2_reason_2_title:
    "Budgetbeschränkungen oder finanzielle Schwierigkeiten",
  cancel_subscription_category_2_reason_3_title:
    "Zu viel Arbeitsaufwand, um das System zu verwalten",
  cancel_subscription_category_2_reason_4_title:
    "Schließung oder Verkleinerung des Unternehmens",
  cancel_subscription_category_2_reason_5_title:
    "Keine Zeit, um Buchungen zu verwalten",
  cancel_subscription_category_3_title: "Preis- und Wettbewerbsfaktoren",
  cancel_subscription_category_3_reason_1_title:
    "Günstigere Alternativen verfügbar",
  cancel_subscription_category_3_reason_2_title:
    "Preiserhöhung oder Änderung des Abrechnungsmodells",
  cancel_subscription_category_4_title: "Probleme mit der Benutzererfahrung",
  cancel_subscription_category_4_reason_1_title:
    "Schwierigkeiten bei der Navigation im System",
  cancel_subscription_category_4_reason_2_title: "Fehlende wichtige Funktionen",
  cancel_subscription_category_4_reason_3_title:
    "Zu kompliziert für mein Team oder Unternehmen",
  cancel_subscription_category_4_reason_4_title:
    "Langsamer oder wenig hilfreicher Kundenservice",
  cancel_subscription_category_4_reason_5_title:
    "Begrenzte Anpassungsmöglichkeiten",
  cancel_subscription_category_4_reason_6_title:
    "Komplizierter Einrichtungs- oder Implementierungsprozess",
  cancel_subscription_category_5_title: "Externe und marktbedingte Faktoren",
  cancel_subscription_category_5_reason_1_title:
    "Änderungen in Markttrends (z. B. Wechsel zu Buchungen über soziale Medien)",
  cancel_subscription_category_5_reason_2_title:
    "Wirtschaftskrise oder Abschwung",
  cancel_subscription_category_5_reason_3_title:
    "Änderungen in den gesetzlichen Vorschriften",
  cancel_subscription_category_6_title: "Sonstiges",
  cancel_subscription_category_6_reason_1_title: "Grund nicht aufgeführt",
  cancel_subscription_category_6_reason_2_title:
    "Ich möchte keinen Grund angeben",
  cancel_plan_and_delete_data: "Kündigen und meine Daten löschen",
  cancel_plan_do_nothing: "Nichts tun",
  cancel_plan_and_keep_data_confirmation_label:
    "Bist du sicher, dass du dein Abonnement kündigen, aber deine Daten behalten möchtest?",
  cancel_plan_and_keep_data_confirmation_info:
    "Das Abonnement wird am Ende des bereits bezahlten Abrechnungszeitraums gekündigt. Die Daten werden sicher auf unseren Servern gespeichert und können jederzeit nach der Reaktivierung des Abonnements wiederhergestellt werden.",
  scheduled_cancel_keeps_data_info:
    "Dein Plan wird gekündigt, aber deine Daten bleiben gespeichert",
  no_just_checking_title: "Nein, ich schaue nur",
  payment_deadline_before_start_variable:
    "Zahlungsfrist vor Beginn jeder wiederkehrenden Buchung",
  send_payment_reminder_before_start_variable:
    "Zeit der Zahlungserinnerungsbenachrichtigung vor der Buchung",
  booking_awaiting_payment_full_description:
    "Vollständige Informationen zur erforderlichen Zahlung",
  booking_awaiting_payment_full_description_example:
    "Die Buchung wird storniert, wenn keine Zahlung innerhalb von 30 min erfolgt. Klicke unten, um zu deiner Buchung zu gelangen und die Zahlung vorzunehmen.",
  recurring_meeting_in_the_past_warning:
    'Ein wiederkehrendes Meeting mit Startdaten in der Vergangenheit kann nicht erstellt werden. Wähle ein Startdatum in der Zukunft oder deaktiviere die Option "Regelmäßig wiederholen".',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Kalenderkonflikt erkannt",
  booking_overlaps_dialog_message:
    "Bei der Überprüfung der Verfügbarkeit haben wir festgestellt, dass der ausgewählte Termin mit bestehenden Buchungen oder Sperrzeiten kollidiert. Konfliktdetails:",
  booking_overlaps_count: "Anzahl der kollidierenden Buchungen",
  unavailable_slot_overlaps_count: "Anzahl der kollidierenden Sperrzeiten",
  booking_overlaps_dialog_question: "Möchtest du trotzdem fortfahren?",
  selected_date: "Ausgewähltes Datum",
  single_booking: "Einzelbuchung",
  external_api_service_not_enabled_error:
    "Leider ist die API-Funktion für dieses Konto nicht verfügbar.",
  service_not_available_at_selected_time:
    "Der Service ist zum ausgewählten Zeitpunkt nicht verfügbar.",
  offline_mode: "Du bist offline",
  offline_description:
    "Die Anwendung benötigt eine Internetverbindung zum Funktionieren.",
  retry: "Erneut versuchen",
  checking_connection: "Verbindung wird überprüft...",
  waiting_for_connection: "Warten auf Verbindung",
  "2fa_verify_title": "Zwei-Faktor-Authentifizierung",
  "2fa_verify_description":
    "Gib deinen 6-stelligen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode:",
  "2fa_recovery_code_label": "Wiederherstellungscode",
  "2fa_use_recovery_code": "Wiederherstellungscode verwenden",
  "2fa_use_app_code": "App-Code verwenden",
  "2fa_verify_incorrect_error":
    "Der 2FA-Code ist falsch. Bitte versuche es erneut.",
  "2fa_session_expired_error":
    "Deine 2FA-Sitzung ist abgelaufen. Bitte melde dich erneut an.",
  "2fa_verification_cancelled":
    "Die Zwei-Faktor-Authentifizierung wurde abgebrochen. Bitte versuche es erneut.",
  enable_2fa: "2FA aktivieren",
  enable_2fa_title: "2-Stufen-Verifizierung aktivieren",
  disable_2fa: "2FA deaktivieren",
  disable_2fa_title: "2-Stufen-Verifizierung deaktivieren",
  "2fa_manual_setup": "Kann nicht scannen? Gib diesen Code manuell ein:",
  "2fa_recovery_codes_title": "Wiederherstellungscodes",
  "2fa_download_codes": "Codes herunterladen",
  "2fa_disable_description":
    "Du bist dabei, die 2-Stufen-Verifizierung zu deaktivieren. Das macht dein Konto weniger sicher.",
  "2fa_disable_warning":
    "Das Deaktivieren der 2-Stufen-Verifizierung verringert die Sicherheit deines Kontos.",
  "2fa_verify_to_disable": "Identität überprüfen",
  "2fa_verify_to_disable_description":
    "Gib einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  warning: "Warnung",
  current_password: "Aktuelles Passwort",
  incorrect_password: "Falsches Passwort. Bitte versuche es erneut.",
  "2fa_setup_failed": "2FA-Einrichtung fehlgeschlagen",
  "2fa_activation_failed": "2FA-Aktivierung fehlgeschlagen",
  "2fa_verification_code": "Verifizierungscode",
  "2fa_disabled_success": "2FA wurde erfolgreich deaktiviert",
  "2fa_disable_failed": "2FA-Deaktivierung fehlgeschlagen",
  "2fa_step_1_password_title": "Passwort eingeben",
  "2fa_step_1_scan_title": "QR-Code scannen",
  "2fa_step_2_verify_title": "Einrichtung überprüfen",
  "2fa_authenticator_apps_required": "Authenticator-App erforderlich",
  "2fa_setup_secure_subtitle":
    "Wähle und installiere eine sichere 2FA-App zum Schutz deines Kontos",
  "2fa_apps_installation_note":
    "Installiere eine dieser Apps auf deinem Handy, bevor du mit der Einrichtung fortfährst.",
  "2fa_scan_with_app": "Scanne diesen QR-Code mit deiner Authenticator-App",
  "2fa_enter_code_from_app":
    "Gib den 6-stelligen Code aus deiner Authenticator-App ein",
  "2fa_recovery_codes_warning":
    "Bewahre diese Codes an einem sicheren Ort auf. Jeder Code kann nur einmal verwendet werden.",
  "2fa_enter_password_to_continue":
    "Gib dein aktuelles Passwort ein, um deinen einzigartigen QR-Code zu generieren",
  "2fa_enter_password_to_disable":
    "Gib dein aktuelles Passwort ein, um die Deaktivierung der 2FA zu bestätigen",
  "2fa_disable_verification_description":
    "Gib dein aktuelles Passwort und einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  "2fa_recovery_codes_description":
    "Diese Backup-Codes ermöglichen dir den Zugang zu deinem Konto, falls du deine Authenticator-App verlierst. Jeder Code kann nur einmal verwendet werden, bewahre sie an einem sicheren Ort auf.",
  security_settings: "Sicherheitseinstellungen",
  security_settings_description:
    "Verwalte deine Kontosicherheitseinstellungen und Authentifizierungsmethoden.",
  "2fa_security_title": "2-Stufen-Verifizierung",
  "2fa_security_description":
    "Füge deinem Konto eine zusätzliche Sicherheitsebene mit der 2-Stufen-Verifizierung hinzu.",
  reset_password_description:
    "Sende einen Link zum Zurücksetzen des Passworts an deine E-Mail-Adresse.",
  "2fa_enabled_success": "2FA wurde erfolgreich aktiviert",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input: "Link zu einem LinkedIn-Profil",
  logs_diff_linkedin: "Link zu einem LinkedIn-Profil",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Link zu einem TikTok-Profil",
  logs_diff_tiktok: "Link zu einem TikTok-Profil",
  wb_linkedin: "LinkedIn-URL",
  wb_tiktok: "TikTok-URL",
};
